// Single source of truth for the backend base URL.
//
// Phase 1 of the WAF rollout leaves this on the direct Cloud Functions host so
// nothing changes. Phase 2 sets REACT_APP_API_BASE_URL to the load balancer
// domain, which is the point at which production traffic starts flowing through
// Cloud Armor. Keeping it in one place makes that cutover — and its rollback —
// a single environment variable.
const API_BASE = process.env.REACT_APP_API_BASE_URL
  || `https://europe-west2-${process.env.REACT_APP_PLATFORM_FIREBASE_PROJECT_ID}.cloudfunctions.net`;

export const functionEndpoint = (name) => `${API_BASE}/${name}`;
